import {
  FETCH_EBT_RETAIL_CONSUMERS_REQUEST,
  FETCH_EBT_RETAIL_CONSUMERS_SUCCESS,
  FETCH_EBT_RETAIL_CONSUMERS_FAILURE,
  SEND_EBT_REQUEST,
  SEND_EBT_SUCCESS,
  SEND_EBT_FAILURE
} from "../actions/ebt_retail_consumers";

const initialState = {
  ebt_retail_consumers: [],
  total_ebt_retail_consumers: 0,
  loading: false,
  error: null
};

const ebtRetailConsumersReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_EBT_RETAIL_CONSUMERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_EBT_RETAIL_CONSUMERS_SUCCESS:
      return {
        ...state,
        loading: false,
        ebt_retail_consumers: action.payload.data,
        total_ebt_retail_consumers: action.payload.total
      };
    case FETCH_EBT_RETAIL_CONSUMERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case SEND_EBT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case SEND_EBT_SUCCESS:
      return {
        ...state,
        loading: false
      };
    case SEND_EBT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default ebtRetailConsumersReducer;
